/*********** Reduceres defined here *********/

import { persistCombineReducers } from 'redux-persist';
import storage from 'redux-persist/es/storage'; // default: localStorage if web, AsyncStorage if react-native
import { encryptTransform } from 'redux-persist-transform-encrypt';

import user from './modules/user';
import loader from './modules/loader';
import search from './modules/search';
import environment from '../../environment';


// Encryption transform
const encryptTransformF = encryptTransform({
    secretKey: environment.secretKey,
});


const userPersistConfig = {
    key: 'grooveguide-admin',
    storage: storage,
    blacklist: ['loader'],
    transforms: [encryptTransformF],
};

export default persistCombineReducers(userPersistConfig, {
    loader,
    user,
    search
});
